import getStorage from '@web/helpers/storage'

import {StateSaverStorageData} from './interfaces'

const STATE_SAVER_KEY = 'STATE_SAVER_KEY'

const SaverKeySplit = '|'

const cachedStorage = <S>(secureStorageKey: string) => getStorage<StateSaverStorageData<S>>(secureStorageKey)

export const saveStateToStorage = <S>({
    secureStorageKey = STATE_SAVER_KEY,
    saverKey,
    currentState,
}: {
    secureStorageKey?: string
    saverKey: string | string[]
    currentState: S
}) => {
    try {
        const storage = cachedStorage<S>(secureStorageKey)
        storage.remove()
        storage.set({key: typeof saverKey === 'string' ? saverKey : saverKey.join(SaverKeySplit), state: currentState})
        return true
    } catch {
        return false
    }
}

// 동일 키로 저장된 state 값이 있는지 확인
export const hasSavedState = <S>({
    secureStorageKey = STATE_SAVER_KEY,
    saverKey,
}: {
    secureStorageKey?: string
    saverKey: string | string[]
}) => {
    try {
        const saverData = cachedStorage<S>(secureStorageKey).get({})

        return saverData?.key.split(SaverKeySplit).some((key) => saverKey.includes(key))
    } catch {
        return false
    }
}
export const getSavedStateFromStorage = <S>({
    secureStorageKey = STATE_SAVER_KEY,
    saverKey,
}: {
    secureStorageKey?: string
    saverKey: string | string[]
}) => {
    if (!hasSavedState<S>({secureStorageKey, saverKey})) {
        return null
    }

    return cachedStorage<S>(secureStorageKey).get({}).state ?? null
}
